import React from 'react';
import {FIND_ALL_CAMPANHA as query} from '../../graphql/queries';
import {SelectBase} from './mui-base';

const transformOptions = ({content}) => {
  return Array.isArray(content)
    ? content.map(item => ({
      ...item,
      label: `[${item.numero}] ${item.titulo}`,
      value: item.id
    }))
    : [];
};

const getVariables = ({pageNumber, search = '', searchDTO = {}, pageSize = 20}) => {
  return {
    pageable: {pageNumber, pageSize, sortField: 'numero', sortDir: 'DESC'},
    searchDTO: {
      ...searchDTO,
      search
    }
  };
};

export const SelectCampanhas = (props) => {
  return (
    <SelectBase
      label="Campanha"
      responseObjectName="findAllCampanha"
      transformOptions={transformOptions}
      query={query}
      getVariables={(searchProps) => getVariables({...searchProps, ...props})}
      {...props}
    />
  );
};
